(() => {
  const initTabs = (root) => {
    if (root.dataset.clHyTabsReady === 'true') return;
    root.dataset.clHyTabsReady = 'true';
    const tabs = [...root.querySelectorAll('[data-cl-hy-tab]')];
    const panels = [...root.querySelectorAll('[data-cl-hy-panel]')];
    if (!tabs.length || !panels.length) return;

    const select = (tab, focus = false) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
      if (focus) tab.focus();
    };

    root.clHyActivateHash = (hash, scroll = false) => {
      if (!hash || hash === '#') return false;

      let target;
      try {
        target = document.getElementById(decodeURIComponent(hash.slice(1)));
      } catch (_error) {
        return false;
      }
      if (!target) return false;

      let panel = target.closest('[data-cl-hy-panel]');
      if (panel && !root.contains(panel)) panel = null;
      if (!panel && target.id === 'reviews' && target.contains(root)) {
        panel = panels.find((item) => item.querySelector('#stamped-main-widget'));
      }
      if (!panel) return false;

      const tab = tabs.find((item) => item.getAttribute('aria-controls') === panel.id);
      if (!tab) return false;
      select(tab);

      if (scroll) {
        requestAnimationFrame(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      }
      return true;
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        select(tabs[next], true);
      });
    });

    root.clHyActivateHash(location.hash, true);
  };

  const activateHash = (hash, scroll = false) => {
    let activated = false;
    document.querySelectorAll('[data-cl-hy-tabs]').forEach((root) => {
      if (typeof root.clHyActivateHash === 'function' && root.clHyActivateHash(hash, scroll)) {
        activated = true;
      }
    });
    return activated;
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cl-hy-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-cl-hy-order]').forEach((link) => {
      if (link.dataset.clHyOrderReady === 'true') return;
      link.dataset.clHyOrderReady = 'true';
      link.addEventListener('click', (event) => {
        const buybox = document.querySelector('[data-cl-buybox], [data-cl-buybox-root]');
        if (!buybox) return;
        event.preventDefault();
        buybox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const url = new URL(link.href, location.href);
    const samePage =
      url.origin === location.origin &&
      url.pathname === location.pathname &&
      url.search === location.search;
    if (!samePage || !url.hash || !activateHash(url.hash, true)) return;

    event.preventDefault();
    history.pushState(null, '', url.hash);
  });
  window.addEventListener('hashchange', () => activateHash(location.hash, true));

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => init(), { once: true })
    : init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
